import { render, staticRenderFns } from "./SelectCard.vue?vue&type=template&id=3d594dea&scoped=true&"
import script from "./SelectCard.vue?vue&type=script&lang=js&"
export * from "./SelectCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d594dea",
  null
  
)

export default component.exports